import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Paginator } from 'array-paginator'
import {
  faAngleRight,
  faAngleDoubleRight,
  faAngleLeft,
  faAngleDoubleLeft
} from '@fortawesome/free-solid-svg-icons'
import useMediaQuery from '@mui/material/useMediaQuery'
import Box from '@mui/material/Box'
import { MobilePaginationBar } from '../components/mobile'
import { layoutMobileMediaQuery } from './layoutConstants'

export function LocalPagination({ data, onPageChange, searchInput, display }) {
  const isCompact = useMediaQuery(layoutMobileMediaQuery)
  const [paginator, setPaginator] = useState(() => new Paginator(data || [], 50, 1))

  useEffect(() => {
    if (data?.length >= 0) {
      const pg = new Paginator(data, 50, 1)
      setPaginator(pg)
      onPageChange(pg.first())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, searchInput])

  const navigate = (id) => {
    setPaginator((prev) => {
      const pg = new Paginator(data || [], 50, prev.current)
      let slice
      if (id === 'first-page' && pg.hasFirst()) {
        slice = pg.first()
      } else if (id === 'previous-page' && pg.hasPrevious()) {
        slice = pg.previous()
      } else if (id === 'next-page' && pg.hasNext()) {
        slice = pg.next()
      } else if (id === 'last-page' && pg.hasLast()) {
        slice = pg.last()
      }
      if (slice !== undefined) {
        onPageChange(slice)
        return new Paginator(data || [], 50, pg.current)
      }
      return prev
    })
  }

  if (!display) {
    return null
  }

  if (isCompact) {
    return (
      <Box sx={{ width: 1, minWidth: 0, mt: 2 }}>
        <MobilePaginationBar
          current_page={paginator.current}
          total_pages={paginator.total}
          onNavigate={navigate}
          ariaLabel="Paginación de listado"
        />
      </Box>
    )
  }

  return (
    <ul className="pagination">
      <li className="page-item">
        <a onClick={() => navigate('first-page')} id="first-page" className="page-link cursor-pointer disabled">
          <FontAwesomeIcon icon={faAngleDoubleLeft} id="first-page" />
        </a>
      </li>
      <li className="page-item">
        <a onClick={() => navigate('previous-page')} id="previous-page" className="page-link cursor-pointer">
          <FontAwesomeIcon icon={faAngleLeft} id="previous-page" />
        </a>
      </li>
      <li onClick={() => navigate('next-page')} className="page-item">
        <a id="next-page" className="page-link cursor-pointer">
          <FontAwesomeIcon icon={faAngleRight} id="next-page" />
        </a>
      </li>
      <li className="page-item">
        <a onClick={() => navigate('last-page')} id="last-page" className="page-link cursor-pointer">
          <FontAwesomeIcon icon={faAngleDoubleRight} id="last-page" />
        </a>
      </li>
      <div className="pagination-label">
        <b>
          {paginator?.current} de {paginator?.total} páginas
        </b>
      </div>
    </ul>
  )
}
